"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.Input = exports.Subheading = exports.Heading = exports.Text = exports.SVG = exports.Image = exports.Flex = exports.Box = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var clear = (0, _styledSystem.style)({
  prop: 'clear'
});
var columns = (0, _styledSystem.style)({
  prop: 'columns'
});
var cursor = (0, _styledSystem.style)({
  prop: 'cursor'
});
var fill = (0, _styledSystem.style)({
  prop: 'fill',
  key: 'colors'
});
var float = (0, _styledSystem.style)({
  prop: 'float'
});
var outline = (0, _styledSystem.style)({
  prop: 'outline'
});
var overflowX = (0, _styledSystem.style)({
  prop: 'overflowX',
  cssProperty: 'overflow-x'
});
var overflowY = (0, _styledSystem.style)({
  prop: 'overflowY',
  cssProperty: 'overflow-y'
});
var whiteSpace = (0, _styledSystem.style)({
  prop: 'whiteSpace'
});
var boxStyle = (0, _styledSystem.variant)({
  prop: 'boxStyle',
  key: 'boxStyles'
});

var Box = _styledComponents.default.div.withConfig({
  displayName: "core__Box",
  componentId: "wi86m4-0"
})(_styledSystem.space, _styledSystem.alignSelf, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.backgroundSize, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.borderRadius, _styledSystem.bottom, _styledSystem.boxShadow, clear, _styledSystem.color, columns, cursor, _styledSystem.display, _styledSystem.flex, _styledSystem.flexBasis, float, _styledSystem.fontSize, _styledSystem.height, _styledSystem.left, _styledSystem.maxHeight, _styledSystem.maxWidth, _styledSystem.minHeight, _styledSystem.minWidth, _styledSystem.opacity, _styledSystem.order, outline, _styledSystem.overflow, overflowX, overflowY, _styledSystem.position, _styledSystem.right, _styledSystem.top, _styledSystem.width, whiteSpace, _styledSystem.zIndex, boxStyle);

exports.Box = Box;
Box.defaultProps = {
  display: 'block'
};
var Flex = (0, _styledComponents.default)(Box)(_styledSystem.flexWrap, _styledSystem.flexDirection, _styledSystem.alignItems, _styledSystem.justifyContent);
exports.Flex = Flex;
Flex.defaultProps = (0, _objectSpread2.default)({}, Box.defaultProps, {
  display: 'flex'
});
var Image = (0, _styledComponents.default)(Box)({});
exports.Image = Image;
Image.defaultProps = (0, _objectSpread2.default)({}, Box.defaultProps, {
  as: 'img',
  display: 'block'
});
var SVG = (0, _styledComponents.default)(Box)(function (p) {
  return {
    '*': (0, _objectSpread2.default)({}, fill(p))
  };
});
exports.SVG = SVG;
SVG.defaultProps = {
  display: 'block'
};
var Text = (0, _styledComponents.default)(Box)(_styledSystem.fontFamily, _styledSystem.fontStyle, _styledSystem.fontWeight, _styledSystem.letterSpacing, _styledSystem.lineHeight, _styledSystem.textAlign, _styledSystem.textStyle);
exports.Text = Text;
var Heading = (0, _styledComponents.default)(Text)({});
exports.Heading = Heading;
Heading.defaultProps = {
  as: 'h2'
};
var Subheading = (0, _styledComponents.default)(Text)({});
exports.Subheading = Subheading;
Subheading.defaultProps = {
  as: 'h3'
};
var Input = (0, _styledComponents.default)(Text)({
  appearance: 'none',
  '&:required': {
    boxShadow: 'none'
  }
});
exports.Input = Input;
Input.defaultProps = {
  as: 'input',
  border: 'none',
  type: 'text'
};
var Button = (0, _styledComponents.default)(Input)({});
exports.Button = Button;
Button.defaultProps = (0, _objectSpread2.default)({}, Input.defaultProps, {
  as: 'button',
  bg: 'transparent',
  border: 0,
  display: 'inline-block',
  lineHeight: 'solid',
  p: 0
});